import React from "react";
import { useState, useEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { getIssues } from "../services/supportIssuesService";
import Table from "../components/common/table";
import { getLuxonDate } from "../utility/dateFunctions";

const SupportIssues = () => {
	const history = useHistory();
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [orderBy, setOrderBy] = useState("DESC");
	const [issues, setIssues] = useState([]);

	const handleDateClick = (id) => {
		console.info("d: " + id);
		history.push("/issue/detail", { params: id });
	};

	const columns = [
		{
			label: "Date/Time",
			icon: "clock",
			content: (result) => (
				<Button variant="link" onClick={() => handleDateClick(result.Id)}>
					{getLuxonDate(result.updatedAt)}
				</Button>
			),
		},
		{
			path: "first_name",
			label: "First Name",
			icon: "user-circle",
		},
		{
			path: "last_name",
			label: "Last Name",
			icon: "user-circle",
		},
		{
			path: "email",
			label: "Email",
			icon: "envelope",
		},
		{
			path: "status",
			label: "Status",
			icon: "question-circle",
		},
	];
	useEffect(() => {
		const loadIssues = async () => {
			const result = await getIssues(currentPage, pageSize, orderBy);
			setIssues(result);
		};

		loadIssues();
	}, [currentPage, pageSize, orderBy]);

	return <Table columns={columns} data={issues} keyColumn="Id" />;
};

export default withRouter(SupportIssues);
